import BranchLocationDetail from './BranchLocationDetail';

export default BranchLocationDetail;
